export default __webpack_public_path__ + "static/media/10k-Gift-Voucher.9108a397.svg";